import { Component } from 'react'
import { observer } from 'mobx-react'

import * as h from 'h'

import Tags from './Tags'
import Contacts from './Contacts'

import styles from './styles.scss'

@observer(['AboutStore'])
class AboutDescription extends Component {
  render () {
    const { AboutStore: { desc } } = this.props

    return h.div(h.ca(styles.desc),
      h.article(null,
        h.img({
          ...h.ca(styles.logo),
          name: '',
          alt: 'Innovation Portal Logo',
          src: '/img/favicon/apple-icon-144x144.png'
        }),
        h.h2(h.ca(styles.title), 'About the Portal'),
        h.raw({ ...h.ca(styles.content), content: desc.content })
      )
    )
  }
}

@observer(['AboutStore', 'UiStore'])
export default class About extends Component {
  componentWillMount () {
    this.props.AboutStore.fetchData()
  }

  componentDidUpdate () {
    const { AboutStore, params } = this.props
    if (Object.keys(params).length !== 0) {
      AboutStore.selectTagWithId(params.id)
    }
  }

  render () {
    const { AboutStore } = this.props

    return h.div(h.ca(styles.container),
      h.h(AboutDescription),
      h.h1(h.ca(styles.groupName), AboutStore.selectedGroupName),
      h.div(h.ca(styles.groupDescription),
        h.raw({ element: 'article', content: AboutStore.selectedGroupDesc })
      ),
      h.div(h.ca(styles.main),
        h.h(Tags),
        h.h(Contacts)
      )
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/About/index.js